import axios, { AxiosRequestConfig } from 'axios'
import {
    AnapathPrinterPrintConfiguration,
    AnapathPrinterPrintMode,
    AvailablePrinter
} from '@/modules/printModule/services/anapath-printer-rest-client/anapath-printer-rest-client.model'

const LOCAL_PRINT_SERVICE_URL = 'http://localhost:41000'

class AnapathPrinterRestClientService {
    async getLocalPrinters(): Promise<AvailablePrinter[]> {
        const response = await axios.get<AvailablePrinter[]>(`${LOCAL_PRINT_SERVICE_URL}/printers`)
        return response.data
    }

    async getWorkstation(): Promise<string> {
        const response = await axios.get<string>(`${LOCAL_PRINT_SERVICE_URL}/workstation`)
        return response.data
    }

    async getPrintServiceStatus(): Promise<void> {
        const response = await axios.get<void>(`${LOCAL_PRINT_SERVICE_URL}/status`)
        return response.data
    }

    private static async _print(
        document: Blob,
        encodedPrinterName: string,
        config: AnapathPrinterPrintConfiguration
    ): Promise<string> {
        const requestConfig: AxiosRequestConfig = {
            headers: {
                'Content-Type': 'text/plain'
            }
        }
        if (config.timeout) {
            requestConfig.timeout = config.timeout
        }
        if (config.params) {
            requestConfig.params = {
                ...config.params
            }
        }

        const response = await axios.put<string>(
            `${LOCAL_PRINT_SERVICE_URL}/printers/${encodedPrinterName}/${config.printMode}`,
            document,
            requestConfig
        )
        return response.data
    }

    async printLabels(data: Blob, device: any): Promise<string> {
        const printerCode = device.selectedPrinter.code
        const config: AnapathPrinterPrintConfiguration = {
            printMode: AnapathPrinterPrintMode.PRINT_LABELS,
            timeout: 300000 // milliseconds
        }
        return AnapathPrinterRestClientService._print(data, printerCode, config)
    }

    async printReports(data: Blob, device: any): Promise<string> {
        const printerCode = device.selectedPrinter.code
        const config: AnapathPrinterPrintConfiguration = {
            printMode: AnapathPrinterPrintMode.PRINT
        }
        return AnapathPrinterRestClientService._print(data, printerCode, config)
    }

    async printCassette(data: Blob, device: any, trayName: string): Promise<string> {
        const printerCode = device.selectedPrinter.code
        const config: AnapathPrinterPrintConfiguration = {
            printMode: AnapathPrinterPrintMode.PRINT_LABELS,
            params: {
                trayName
            }
        }
        return AnapathPrinterRestClientService._print(data, printerCode, config)
    }
}

export const anapathPrinterRestClientService = new AnapathPrinterRestClientService()
